export default __webpack_public_path__ + "static/media/210-result-2.a9166515.svg";